module.exports = __webpack_public_path__ + "static/hero-378b14483fe78c296fdf9fbda34c6d88.jpg";